import React from 'react'
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import CCOHeadline from '../../fundamentals/CCOHeadline';
import CCOOverlay from "../../fundamentals/CCOOverlay";
import C046FormEditor from "../C046FormEditor/C046FormEditor";
import PreviewElementBoxDrawer from "../../preview/PreviewElementBoxDrawer";
import CCOResponsivePicture from "../../fundamentals/CCOResponsivePicture";
import {C062OverlayFormPictureSettings} from "../../../common/constants/pictureSettings";
import { getLengthLimit } from "../../../utility/lengthLimits";
import { usePreviewLimitCheck } from "../../preview/usePreviewLimitCheck";


export interface Props {
    id: string,
    breakpoints: any,
    formData: any | null | undefined,
    isPreview?: boolean,
    pageSettings: Array<any>,
    picture: any,
    subtitle: string | null | undefined,
    title: string | null |undefined,
    token: string,
    fcSiteKey?: string
}

function C062OverlayForm({
                             breakpoints,
                             formData,
                             isPreview,
                             pageSettings,
                             picture,
                             subtitle,
                             title,
                             token,
                             id,
                             fcSiteKey
                         }: Props) {
    const primaryLimit = getLengthLimit('C062OverlayForm.headlinePrimary');
    const secondaryLimit = getLengthLimit('C062OverlayForm.headlineSecondary');

    usePreviewLimitCheck({
        id,
        component: 'C062OverlayForm',
        field: 'title',
        value: title || '',
        limit: primaryLimit,
        source: 'default',
    });
    usePreviewLimitCheck({
        id,
        component: 'C062OverlayForm',
        field: 'subtitle',
        value: subtitle || '',
        limit: secondaryLimit,
        source: 'default',
    });

    return (
        <>
            <CCOOverlay isPreview={isPreview} breakpoints={breakpoints} withAutoOpen
                        autoOpenKey="formOverlayShown">
                <Box sx={{
                    display: 'flex',
                    flexGrow: 1,
                    width: {
                        xs: '320px',
                        sm: '500px',
                        md: '900px',
                    },
                    maxHeight: {
                        xs: '548px',
                        sm: '548px',
                        md: '548px',
                        lg: '548px',
                        xl: '748px',
                    },
                }}>
                    <Grid container columns={{xs: 6, sm: 6, lg: 6}} sx={{
                        flexDirection: {xs: 'row', md: 'column'}, alignContent: 'flex-start',
                    }}>
                        <Grid size={{lg: 6}} sx={{
                            width: {
                                xs: '100%',
                                md: '309px',
                                lg: '375px',
                            },
                            lineHeight: 0,
                        }}>
                            <CCOResponsivePicture pictureSetting={C062OverlayFormPictureSettings}
                                                  picture={picture}
                                                  imageStyle={{width: "100%", height: "auto"}}/>
                        </Grid>
                        <Grid sx={{
                            backgroundColor: 'background.default',
                            maxWidth: {
                                md: '490px',
                                lg: '525px'
                            }
                        }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                alignSelf: 'stretch',
                                gap: 4,
                                padding: {
                                    xs: '24px 16px 16px 16px',
                                    lg: '32px 32px 48px 32px'
                                },
                            }}>
                                <PreviewElementBoxDrawer propertyId={id}>
                                    <CCOHeadline metadataId={id} type='h3'
                                                 headline={title}
                                                 headlineCharLimit={getLengthLimit('C062OverlayForm.headlinePrimary')}
                                                 propertyName='properties.title'
                                                 color='text.primary'
                                                 justify='left'
                                    />
                                    <CCOHeadline metadataId={id} type='body1'
                                                 headline={subtitle}
                                                 headlineCharLimit={getLengthLimit('C062OverlayForm.headlineSecondary')}
                                                 propertyName='properties.subtitle'
                                                 color='text.primary'
                                                 justify='left'
                                    />
                                </PreviewElementBoxDrawer>
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: 'block',
                                        'form': {lineHeight: 0}
                                    }}>
                                    <C046FormEditor id={formData.id} formEditor={formData}
                                                    csrfToken={token} fullWidth
                                                    pageSettings={pageSettings} fcSiteKey={fcSiteKey}
                                                    drymode={false} isOverlayForm/>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </CCOOverlay>
        </>
    );
}

export default C062OverlayForm;